<template>
    <div>
        <div class="content-header">
            <div class="content-header-left mb-2">
                <div class="breadcrumbs-top">
                    <h2 class="content-header-title mb-0">{{ title }}</h2>
                    <div class="breadcrumb-wrapper">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="role_id == 2 ? '/' : '/kontrak'">
                                    <i class="feather icon-home"></i>
                                </router-link>
                            </li>

                            <li class="breadcrumb-item" :class="data.active == true ? 'active' : ''" style="text-transform: capitalize" v-for="(data, index) in breadcumb" :key="index">
                                <router-link :to="data.link">{{ data.name }}</router-link>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section id="basic-datatable">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <ValidationObserver v-slot="{ invalid }" class="card-content">
                                <div class="card-body card-dashboard">
                                    <h3 class="font-bold text-primary mb-2">Edit Kontraktor</h3>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <ValidationProvider name="model.name" v-slot="{ errors }" rules="required">
                                                <div class="form-group" :class="{ 'validation-warning': errors[0] }">
                                                    <label for="">Nama Kontraktor</label>
                                                    <input type="text" v-model="model.name" id="" class="form-control">
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-md-6">
                                            <ValidationProvider name="model.no_telp" v-slot="{ errors }" rules="required|numeric">
                                                <div class="form-group" :class="{ 'validation-warning': errors[0] }">
                                                    <label for="">No. Telepon</label>
                                                    <input type="text" v-model="model.no_telp" id="" class="form-control">
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <ValidationProvider name="model.alamat" v-slot="{ errors }" rules="required">
                                                <div class="form-group" :class="{ 'validation-warning': errors[0] }">
                                                    <label for="">Alamat</label>
                                                    <textarea v-model="model.alamat" class="form-control" id="" cols="30" rows="5"></textarea>
                                                </div>
                                            </ValidationProvider>
                                        </div>

                                        <div class="col-md-6">
                                            <label for="">Status</label>
                                            <ValidationProvider name="model.status" rules="required">
                                                <div class="custom-control custom-switch custom-control-inline mt-1">
                                                    <input type="checkbox" v-model="model.status" class="custom-control-input"
                                                        id="customSwitch1">
                                                    <label class="custom-control-label" for="customSwitch1">
                                                    </label>
                                                    <span class="switch-label">{{ model.status ? 'Aktif' : 'Tidak Aktif' }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>

                                    <div class="d-flex flex-wrap justify-content-end align-items-center">
                                        <router-link to="/kontraktor" class="btn btn-outline-primary mr-1 btn-lg" data-dismiss="modal">Batal</router-link>
                                        <button type="button" :disabled="invalid" @click="save()" class="btn btn-primary btn-lg" data-dismiss="modal">Simpan</button>
                                    </div>
                                </div>
                            </ValidationObserver>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            title: "Kontraktor",
            breadcumb: [
                {
                    name: 'Master Data', 
                    link: '',
                    active: false
                },
                {
                    name: 'Kontraktor',
                    link: '/kontraktor',
                    active: false
                },   
                {
                    name: 'Edit Kontraktor', 
                    link: '',
                    active: true
                }            
            ],
            model: [],
            role_id: localStorage.getItem('role_id')
        }
    },
    methods: {
        get() {
            let _ = this
            _.axios.get('/kontraktor?id=' + _.$route.params.id)
                .then(resp=>{
                    _.model = resp.data.data.rows
                })
                .catch(err=>{
                    console.log(err.response)
                })
        },
        save() {
            let _ = this
            _.axios.patch('/kontraktor', _.model)
                .then(resp => {
                    if (resp.status) {
                        _.$router.push('/kontraktor')
                    }else{
                        console.log("Failed")
                    }
                })
                .catch(err=>{
                    console.log(err.response)
                })
        }
    },
    mounted() {
        let _ = this
        _.get()
    },
}
</script>